// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"39b7d937","126":"7336c8f5","132":"25e30ae7","527":"6262ccc4","655":"1086863a","869":"6b7f6534"}[chunkId] + ".chunk.js";
};